module.exports = __webpack_public_path__ + "img/08_Mobile Scanner Stand.84f219d1.png";